import { Checkbox, DefaultButton, Icon, IconButton, Panel, PanelType, PrimaryButton } from 'office-ui-fabric-react';
import { CommandBar } from 'office-ui-fabric-react/lib/CommandBar';
import { ConstrainMode, DetailsList, SelectionMode } from 'office-ui-fabric-react/lib/DetailsList';
import { ScrollablePane, ScrollbarVisibility } from 'office-ui-fabric-react/lib/ScrollablePane';
import { SearchBox } from 'office-ui-fabric-react/lib/SearchBox';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { Sticky, StickyPositionType } from 'office-ui-fabric-react/lib/Sticky';
import React, { Component, Fragment } from 'react';
import Scriba from 'react-scriba';
import PerimetreContext from '../../contexts/PerimetreContext';
import { DataDemande } from '../../data/DataDemande';
import { DataRelance } from '../../data/DataRelance';
import { IDS_TYPE_TRANSMISSION } from '../../data/DataTypeTransmission';
import { Immocom } from '../../specifique/immocom';
import { EUIDialog } from '../EUI/EUIDialog';
import { FicheAlarmes } from '../Fiche/FicheAlarmes';
import { FicheDemande } from '../Fiche/FicheDemande';
import { FicheRelance } from '../Fiche/FicheRelance';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../Outils/MessageBars';

/*
**********************************************************************************************************************
PROPS :
    ATTRIBUTS :
        -
    METHODES :
        -
**********************************************************************************************************************
*/

export class DetailsListDemande extends Component {
    static contextType = PerimetreContext;
    render = () => {
        const { perimetre } = this.context;
        return <DetailsListDemandeWithPerimetre {...this.props} perimetre={perimetre} />;
    };
};

class DetailsListDemandeWithPerimetre extends Component {

    static defaultProps = {
        idOperation: undefined,
        idReservation: undefined,
        perimetre: {}
    };

    constructor(props) {
        super(props);
        this._columns = this._getColumns();
        this._filtres = this._getFiltres();
        this._isSortedDescending = true;
        this._sortedColumn = "dateDemande";
        this._objetState = {
            items: [],
            itemActif: {},
            /* --- */
            pageIndex: 1,
            facteurNbreEnregistrement: 100,
            /* --- */
            hideMessageBarFiltres: true,
            hideMessageBarWarning: true,
            hideMessageBarError: true
        };
        this.state = { ... this._objetState };
    };

    _creationContent = () => {
        return <DetailsList
            columns={this._columns}
            constrainMode={ConstrainMode.unconstrained}
            items={this.state.items}
            onColumnHeaderClick={this._onClickColumnHeader}
            onRenderDetailsHeader={this._onRenderDetailsHeader}
            onRenderRow={this._onRenderRow}
            selectionMode={SelectionMode.none}
        />
    };

    _appliquerFiltres = (filtres) => {
        this._filtres = { ...this._filtres, ...filtres };
        this.setState({ pageIndex: 1 });
        this._togglePanel("Filtres", false, null, true)();
    };

    _chargementDonnees = () => {
        const { items, facteurNbreEnregistrement, pageIndex } = this.state;

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Chargement des demandes en cours..."
        });

        let chargementDemandesEtRelances = DataDemande._chargementDemandesEtRelances(this._filtres, this._sortedColumn, this._isSortedDescending, facteurNbreEnregistrement, pageIndex);
        chargementDemandesEtRelances.then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                const demandesEtRelances = responseFetch.reponseAPIobjet || [];
                const demandes = demandesEtRelances.map((v, index) => ({ ...v.demande, relances: v.relances }))

                let newItems = [];
                if (pageIndex === 1) {
                    newItems = demandes;
                }
                else {
                    newItems = [...items];
                    newItems = newItems.concat(demandes);
                }

                const state = { items: newItems };
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, state);
            }
            else {
                const state = { items: [] };
                Immocom.onTraitementErreurAvecState(this, state, retourVerif, responseFetch);
            }
        });
    };

    _getColumns = () => {

        const estUneRelance = (item) => !!item.idRelance;
        const estUneDemande = (item) => !estUneRelance(item);

        const getDestinataire = (item) => {
            for (let key of ["compte", "clients", "intervenantEXTSociete", "intervenantEXTPersonne"]) {
                const destinataire = item[key];
                if (!!destinataire) return destinataire;
            };
            return "";
        };

        let columns = [
            {
                isResizable: true,
                key: "acquereurs",
                minWidth: 100,
                maxWidth: 100,
                name: "Acquéreurs",
                onRender: (item) => {
                    if (estUneRelance(item)) return null;
                    const acquereurs = item.acquereurs;
                    return <span title={acquereurs}>{acquereurs}</span>;
                }
            },
            {
                isResizable: true,
                key: "destinataire",
                minWidth: 150,
                maxWidth: 150,
                name: "Destinataire",
                onRender: (item) => {
                    if (estUneRelance(item)) return null;
                    const destinataire = getDestinataire(item);
                    return <span title={destinataire}>{destinataire}</span>;
                }
            },
            {
                isResizable: true,
                key: "demande",
                name: "Demande",
                onRender: (item) => {
                    const message = estUneDemande(item) ? item.demande : item.relance;
                    switch (item.idTypeTransmission) {
                        case IDS_TYPE_TRANSMISSION.COURRIER: var iconName = "PageEdit"; break;
                        case IDS_TYPE_TRANSMISSION.DIRECTE: var iconName = "People"; break;
                        case IDS_TYPE_TRANSMISSION.EMAIL: var iconName = "Mail"; break;
                        case IDS_TYPE_TRANSMISSION.TELEPHONE: var iconName = "Phone"; break;
                        case IDS_TYPE_TRANSMISSION.TCHAT: var iconName = "Chat"; break;
                        default: break;
                    }
                    return <Stack horizontal verticalAlign="center" gap={5}>
                        {!!iconName && <Icon iconName={iconName} />}
                        <div title={message}>{message}</div>
                    </Stack>;
                }
            },
            {
                key: "creerPar",
                minWidth: 100,
                maxWidth: 100,
                name: "Créée par",
                onRender: (item) => {
                    const auteur = item.auteur;
                    return <span title={auteur}>{auteur}</span>;
                }
            },
            {
                key: "dateDemande",
                minWidth: 75,
                maxWidth: 75,
                name: "Envoyée le",
                onRender: (item) => {
                    const date = estUneDemande(item) ? item.dateDemande : item.dateRelance;
                    return <span>{Scriba.date().stringDateFormatCourt(date)}</span>
                }
            },
            {
                isResizable: true,
                key: "reponse",
                minWidth: 200,
                maxWidth: 300,
                name: "Réponse",
                onRender: (item) => {
                    if (estUneRelance(item)) return null;
                    const reponse = item.reponse;
                    return <span title={reponse}>{reponse}</span>;
                }
            },
            {
                key: "dateReponse",
                minWidth: 75,
                maxWidth: 75,
                name: "Rép. reçue le",
                onRender: (item) => {
                    if (estUneRelance(item)) return null;
                    return <span>{Scriba.date().stringDateFormatCourt(item.dateReponse)}</span>;
                }
            },
            {
                iconName: null,
                isIconOnly: true,
                key: "edit",
                minWidth: 20,
                maxWidth: 20,
                onRender: (item) => {
                    const styles = estUneRelance(item) ? { root: { height: "unset" } } : {};
                    return estUneDemande(item)
                        ? <IconButton
                            iconProps={{ iconName: "Edit", styles }}
                            onClick={this._togglePanel("Demande", true, item, false)}
                            styles={styles}
                            title="Consulter/modifier la demande"
                        />
                        : <IconButton
                            iconProps={{ iconName: "View", styles }}
                            onClick={this._togglePanel("Relance", true, item, false)}
                            styles={styles}
                            title="Consulter la relance"
                        />;
                }
            },
            {
                iconName: null,
                isIconOnly: true,
                key: "duplicate",
                minWidth: 20,
                maxWidth: 20,
                onRender: (item) => {
                    if (estUneRelance(item)) return null;
                    const newItem = { ...item, idDemandeADupliquer: item.idDemande };
                    delete newItem.idDemande;
                    return <IconButton
                        iconProps={{ iconName: "Copy" }}
                        onClick={this._togglePanel("Demande", true, newItem, false)}
                        title="Duppliquer la demande"
                    />;
                }
            },
            {
                key: "nombreRelances",
                minWidth: 50,
                maxWidth: 50,
                name: "Relances",
                onRender: (item) => {
                    if (estUneRelance(item)) return null;
                    const badgeTitle = !!item.dateDerniereRelance
                        ? "Dernière relance effectuée le " + Scriba.date().stringDateFormatCourt(item.dateDerniereRelance)
                        : "Aucune relance effectuée";
                    return <Stack horizontal verticalAlign="center">
                        <IconButton
                            iconProps={{ iconName: "MailAlert" }}
                            onClick={this._togglePanel("Relance", true, item, false)}
                            title="Enregistrer une relance"
                        />
                        <span title={badgeTitle} className="badge badge-secondary">{item.nombreRelances}</span>
                    </Stack>
                }
            },
            {
                iconName: null,
                isIconOnly: true,
                key: "delete",
                minWidth: 20,
                maxWidth: 20,
                onRender: (item) => {
                    const title = estUneDemande(item) ? "Supprimer la demande" : "Supprimer la relance";
                    const styles = estUneRelance(item) ? { root: { height: "unset" } } : {};
                    return <IconButton
                        iconProps={{ iconName: "Trash", styles }}
                        onClick={this._toggleDialogSuppression(true, item)}
                        styles={styles}
                        title={title}
                    />;
                }
            },
            {
                iconName: null,
                isIconOnly: true,
                key: "enable",
                minWidth: 20,
                maxWidth: 20,
                onRender: (item) => {
                    if (estUneRelance(item)) return null;
                    const styles = { root: { color: item.actif ? "red" : "green" } };
                    return <IconButton
                        iconProps={{ iconName: "FullCircleMask", styles }}
                        onClick={this._toggleStatus(item)}
                        title={`${item.actif ? "Clore" : "Rouvrir"} la demande`}
                    />;
                }
            },
            {
                iconName: null,
                isIconOnly: true,
                key: "alarmes",
                minWidth: 20,
                maxWidth: 20,
                onRender: (item) => {
                    if (estUneRelance(item)) return null;
                    return <IconButton
                        iconProps={{ iconName: "Ringer" }}
                        onClick={this._togglePanel("Alarmes", true, item, false)}
                        title="Gérer les alarmes"
                    />;
                }
            }
        ];

        if (!this.props.idReservation) columns.unshift({
            fieldName: "lotCommercial",
            key: "lotCommercial",
            minWidth: 50,
            maxWidth: 50,
            name: "Rés.",
        });

        if (!this.props.idOperation) columns.unshift({
            isResizable: true,
            key: "operation",
            minWidth: 200,
            maxWidth: 200,
            name: "Opération",
            onRender: (item) => {
                const operation = item.operation;
                return <span title={operation}>{operation}</span>;
            }
        });

        return columns;
    };

    _getFarItems = () => {
        return [
            {
                key: "nombreEnregistrement",
                name: this.state.items.length
            },
            {
                iconOnly: true,
                iconProps: { iconName: "Filter" },
                key: "filtres",
                name: "Filtres",
                onClick: this._togglePanel("Filtres", true, null, false)
            }
        ];
    };

    _getFiltres = () => {
        const { idOperation, idReservation } = this.props;
        let filtres = { ...PanelFiltres.defaultProps.filtres };
        if (!!idOperation) filtres.idOperation = idOperation;
        if (!!idReservation) filtres.idReservation = idReservation;
        return filtres;
    };

    _getItems = () => {
        return [
            {
                key: "search",
                onRender: () => <SearchBox
                    className="searchBox"
                    onClear={(ev) => this._onSearch("")}
                    onSearch={(newValue) => this._onSearch(newValue)}
                    placeholder="Recherche rapide"
                />
            },
            {
                key: "add",
                name: "Créer une demande",
                iconProps: { iconName: "Add" },
                onClick: this._togglePanel("Demande", true, null, false)
            }
        ];
    };

    _onScroll = (e) => {
        if ((e.target.scrollHeight - e.target.clientHeight) === (Math.trunc(e.target.scrollTop))) {
            this._incrementeNbreEnregistrementEtChargementDonnees();
        }
    }

    _incrementeNbreEnregistrementEtChargementDonnees = () => {
        this.setState(
            prevState => ({ pageIndex: prevState.pageIndex + 1 }),
            this._chargementDonnees
        );
    };

    _onClickColumnHeader = (ev, column) => {
        const key = column.key;
        if (key !== "destinataire") {
            const isSortedDescending = !(column.isSortedDescending || false)

            this._columns.forEach((col) => {
                if (col.key === key) {
                    col.isSortedDescending = isSortedDescending;
                    col.isSorted = true;
                } else {
                    col.isSorted = false;
                    col.isSortedDescending = false;
                }
            });

            this._sortedColumn = key;
            this._isSortedDescending = isSortedDescending;
            this.setState({ pageIndex: 1 }, this._chargementDonnees);
        }
    };

    _onRenderRow = (props, defaultRender) => {
        const relances = props.item.relances || [];
        const subRows = relances.map((relance, index) => {
            const styles = { root: { backgroundColor: "rgb(244, 244, 244)", fontStyle: "italic" } };
            const subProps = { ...props, key: index, compact: true, item: relance, styles };
            return defaultRender(subProps);
        });
        return <Stack>
            {defaultRender(props)}
            {subRows}
        </Stack>
    };

    _onRenderDetailsHeader = (props, defaultRender) => {
        return <Sticky stickyPosition={StickyPositionType.Header} isScrollSynced={true}>
            {defaultRender(props)}
        </Sticky>
    };

    _onSearch = (keyword) => {
        this._filtres.recherche = keyword;
        this.setState({ pageIndex: 1 }, this._chargementDonnees);
    };

    _supprimerItemActif = () => {

        const { itemActif } = this.state;
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: `Suppression de la ${!!itemActif.idRelance ? "relance" : "demande"} en cours...`
        });

        const { idDemande, idRelance } = itemActif;
        const deleteMethod = !!idRelance
            ? () => DataRelance._onSuppressionRelance(idRelance)
            : () => DataDemande._onSuppressionDemande(idDemande);

        deleteMethod().then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                this.setState({ pageIndex: 1 }, this._chargementDonnees);
            }
            else {
                Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
            }
        });
        this._toggleDialogSuppression(false)();

    };

    _toggleDialogSuppression = (isOpen, item) => () => {
        this.setState({
            afficherDialogSuppression: isOpen,
            itemActif: item || {}
        });
    };

    _togglePanel = (nomPanel, isOpen, item, rechargerLesDonnees) => () => {
        this.setState(prevState => (
            {
                [`afficherPanel${nomPanel}`]: isOpen,
                itemActif: item || {},
                pageIndex: rechargerLesDonnees ? 1 : prevState.pageIndex
            }),
            rechargerLesDonnees ? this._chargementDonnees : null
        );
    };

    _toggleStatus = (item) => () => {

        const { idDemande, actif } = item;

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Mise à jour du statut de la demande en cours..."
        });

        DataDemande._onEnregistrementDemande({ idDemande, actif: !actif })
            .then(responseFetch => {
                const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                if (retourVerif === null) {
                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, { pageIndex: 1 }, this._chargementDonnees);
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
                }
            });

    };

    componentDidMount = () => { this._chargementDonnees(); };

    //componentDidUpdate = () => {
    //    if (localStorage.getItem("onRecharge") === "true") {
    //        localStorage.setItem("onRecharge", "false");
    //        this.setState({ pageIndex: 1 }, this._chargementDonnees);
    //    }
    //};

    componentDidUpdate = (prevProps) => {
        const { perimetre } = this.props;
        if (JSON.stringify(prevProps.perimetre) !== JSON.stringify(perimetre))
            this.setState({ pageIndex: 1 }, this._chargementDonnees);
    };

    render = () => {

        const content = this._creationContent();
        const { idOperation, idReservation } = this.props;
        const { itemActif, afficherPanelDemande, afficherPanelAlarmes, afficherPanelRelance, afficherPanelFiltres, afficherDialogSuppression } = this.state;

        return <Fragment>

            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

            <Stack verticalFill>
                <CommandBar
                    ariaLabel={"Utiliser les flèches droite et gauche pour naviguer"}
                    farItems={this._getFarItems()}
                    items={this._getItems()}
                    overflowButtonProps={{ ariaLabel: 'Plus de fonctionnalités' }}
                />
                <MessageBars
                    errorMessage={this.state.errorMessage}
                    infoMessage={this.state.messageMessageBarFiltres}
                    warningMessage={this.state.warningMessage}
                    onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                    onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                />
                <div className="position-relative h-100">
                    <ScrollablePane
                        scrollbarVisibility={ScrollbarVisibility.auto}
                        onScroll={this._onScroll}
                    >
                        {content}
                    </ScrollablePane>
                </div>
            </Stack>

            <FicheDemande
                idDemande={itemActif.idDemande}
                idDemandeADupliquer={itemActif.idDemandeADupliquer}
                idOperation={idOperation}
                idReservation={idReservation}
                isOpen={afficherPanelDemande}
                onDismiss={this._togglePanel("Demande", false, null, false)}
                onEnregistrement={this._togglePanel("Demande", false, null, true)}
            />

            <FicheAlarmes
                afficherAlarmesLieesADemandes
                idDemande={itemActif.idDemande}
                isOpen={afficherPanelAlarmes}
                onDismiss={this._togglePanel("Alarmes", false, null, false)}
            />

            <FicheRelance
                idDemande={itemActif.idDemande}
                idRelance={itemActif.idRelance}
                isOpen={afficherPanelRelance}
                onDismiss={this._togglePanel("Relance", false, null, false)}
                onEnregistrement={this._togglePanel("Relance", false, null, true)}
            />

            <PanelFiltres
                filtres={{ ...this._filtres }}
                isOpen={afficherPanelFiltres}
                onValidation={this._appliquerFiltres}
                onDismiss={this._togglePanel("Filtres", false, null, false)}
            />

            <EUIDialog
                buttons={[
                    <PrimaryButton key="delete" onClick={this._supprimerItemActif} text="Supprimer" />,
                    <DefaultButton key="cancel" onClick={this._toggleDialogSuppression(false)} text="Annuler" />
                ]}
                isOpen={afficherDialogSuppression}
                message={`Confirmez-vous la suppression de cette ${!!itemActif.idRelance ? "relance" : "demande"} ?`}
                onDismiss={this._toggleDialogSuppression(false)}
                titre={`Suppression d'une ${!!itemActif.idRelance ? "relance" : "demande"}`}
            />

        </Fragment>;

    };

};

export class PanelFiltres extends Component {

    /*
    ******************************************************************************************************
    PROPS :
        ATTRIBUTS :
            object  filtres                             liste des filtres (clé/valeur)
            bool    isOpen                              détermine si panel ouvert ou non
        METHODES :
            void    onDismiss                           méthode appelée lorsque l'utilisateur clique sur "Annuler"
            void    onValidation(filtres)               méthode appelée lorsque l'utilisateur clique sur "Valider"
    ******************************************************************************************************
    */

    static defaultProps = {
        filtres: {
            afficherDemandesOuvertes: true,
            afficherDemandesFermees: false,
            nombreRelancesMin: 0,
        }
    };

    constructor(props) {
        super(props);
        this.state = {};
    };

    _appliquerFiltres = () => {
        const { afficherDemandesOuvertes, afficherDemandesFermees, nombreRelancesMin } = this.state;
        const filtres = { afficherDemandesOuvertes, afficherDemandesFermees, nombreRelancesMin };
        this.props.onValidation(filtres);
    };

    _reinitialiserFiltres = () => {
        this.setState({ ...PanelFiltres.defaultProps.filtres });
    };

    _onOpen = () => {
        const { afficherDemandesOuvertes, afficherDemandesFermees, nombreRelancesMin } = this.props.filtres;
        this.setState({ afficherDemandesOuvertes, afficherDemandesFermees, nombreRelancesMin });
    };

    _onRenderFooterContent = () => {
        return <Stack horizontal gap={8}>
            <PrimaryButton onClick={this._appliquerFiltres}>Valider</PrimaryButton>
            <DefaultButton onClick={this.props.onDismiss}>Fermer</DefaultButton>
        </Stack>;
    };

    render = () => {

        return <Panel
            closeButtonAriaLabel="Fermer"
            headerText="Filtres"
            isOpen={this.props.isOpen}
            onDismiss={this.props.onDismiss}
            onOpen={this._onOpen}
            onRenderFooterContent={this._onRenderFooterContent}
            type={PanelType.smallFixedFar}
        >
            <Stack>

                <Stack horizontal reversed>
                    <IconButton
                        iconProps={{ iconName: 'ClearFilter' }}
                        className="buttonFiltres"
                        title="Réinitialiser les filtres"
                        ariaLabel="Filtres"
                        onClick={this._reinitialiserFiltres}
                    />
                </Stack>

                <Checkbox
                    label="Demandes ouvertes"
                    checked={this.state.afficherDemandesOuvertes}
                    onChange={(e, isChecked) => this.setState({ afficherDemandesOuvertes: isChecked })}
                />

                <Checkbox
                    label="Demandes fermées"
                    checked={this.state.afficherDemandesFermees}
                    onChange={(e, isChecked) => this.setState({ afficherDemandesFermees: isChecked })}
                />

                <Checkbox
                    label="Demandes avec relances uniquement"
                    checked={this.state.nombreRelancesMin > 0}
                    onChange={(e, isChecked) => this.setState({ nombreRelancesMin: isChecked ? 1 : 0 })}
                />

            </Stack>
        </Panel>;

    };

};